<template>
  <div class="login-form">
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item prop="username" class="form-item">
        <div class="input-wrapper">
          <div class="input-icon">
            <i class="el-icon-user"></i>
          </div>
          <el-input placeholder="请输入用户名" clearable maxLength="16" v-model.trim="form.username" @keyup.enter.native="login"></el-input>
        </div>
      </el-form-item>
      <el-form-item prop="password" class="form-item">
        <div class="input-wrapper">
          <div class="input-icon">
            <i class="el-icon-key"></i>
          </div>
          <el-input show-password placeholder="请输入密码" clearable :maxLength="32" v-model.trim="form.password" @keyup.enter.native="login"></el-input>
        </div>
      </el-form-item>
      <el-form-item v-if="showVerify" prop="vcode">
        <div class="input-wrapper">
          <div class="input-icon">
            <i class="el-icon-edit-outline"></i>
          </div>
          <el-input placeholder="请输入验证码" clearable maxLength="6" v-model.trim="form.vcode" @keyup.enter.native="login"></el-input>
          <div class="image-code-box" @click="getVerifycode">
            <el-image :src="verifycodeSrc"/>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="form-item checkbox-item">
        <div class="checkbox-wrapper">
          <el-checkbox v-model="remember">
            <span class="checkbox-label">记住密码</span>
          </el-checkbox>
        </div>
      </el-form-item>
    </el-form>
    <el-button type="primary" class="login-btn" @click="login">
      <span class="btn-text">立即登录</span>
    </el-button>
  </div>
</template>

<script>
import {inputEmpty} from "@utils/validate";
import {Base64} from "js-base64";

export default {
  name: "SmsLogin",
  data() {
    return {
      remember: false,
      form: {
        username: process.env.NODE_ENV === "production" ? "" : "admin",
        password: process.env.NODE_ENV === "production" ? "" : "wayos028",
        vcode: "",
      },
      rules: {
        username: [inputEmpty("用户名")],
        password: [inputEmpty("密码")],
        vcode: [inputEmpty("验证码")],
      },
      showVerify: false,
      verifycodeSrc: "",
    }
  },
  created() {
    this.getVerifycode();
    let loginAccount = localStorage.getItem("loginAccount");
    if (loginAccount) {
      loginAccount = JSON.parse(Base64.decode(loginAccount)) || {};
      this.form.username = loginAccount.username;
      this.form.password = loginAccount.password;
      this.remember = true;
    }
  },
  methods: {
    // 获取图片验证码
    async getVerifycode() {
      if (this.showVerify) {
        let res = await this.$Http.getCaptcha();
        if (res?.data) {
          this.verifycodeSrc = `data:image/png;base64,${res.data.verifycode}`;
          this.form.captcha_id = res.data.captcha_id;
          this.form.vcode = "";
        }
      }
    },
    login() {
      this.$refs['form'].validate(async isOk => {
        if (isOk) {
          let nv = {...this.form};
          let res = await this.$Http.login(nv);
          if (res?.data) {
            if (this.remember) {
              localStorage.setItem("loginAccount", Base64.encode(JSON.stringify(nv)));
            } else {
              localStorage.removeItem("loginAccount");
            }
            this.$emit("finish", res.data)
          } else {
            res && (this.showVerify = res.showVerify);
            this.getVerifycode();
          }
        }
      })
    },
    created() {
      this.getVerifycode();
    }
  },
}
</script>



<style scoped lang="scss">

</style>